import request from '@/utils/request'; // 获取楼栋单元列表

export function fetchList(data) {
  return request({
    url: '/pmsservice/api/unint/list',
    method: 'post',
    data: data
  });
} // 添加

export function fetchCreate(data) {
  return request({
    url: '/pmsservice/api/unint/insert',
    method: 'post',
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: '/pmsservice/api/unint/info',
    method: 'post',
    data: data
  });
} // 删除

export function fetchDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: '/pmsservice/api/unint/delete',
    method: 'post',
    data: data
  });
} // 编辑

export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/unint/update',
    method: 'post',
    data: data
  });
} // 导出数据

export function exportList(data) {
  return request({
    url: '/pmsservice/api/unint/exportList',
    method: 'post',
    data: data
  });
} // 导入数据

export function importBatch(data) {
  return request({
    url: '/pmsservice/api/unint/importBatch',
    method: 'post',
    data: data
  });
}